module.exports = __webpack_public_path__ + "img/instituciones-participantes-wpp.bac7d276.png";